import logo from '../assets/images/logo.png';
import ethLgoo from '../assets/images/eth.png';
const data = {
  user: {
    id: 278699491,
    first_name: 'Emmanuel',
    last_name: "Ademu (won't ask you for money)",
    username: 'emmyjay',
    language_code: 'en',
    allows_write_to_pm: true,
  },
  chat_instance: '8110049788557690445',
  chat_type: 'sender',
  start_param: 'qwer',
  auth_date: '1715000453',
  hash: 'd68f66763c03179bb2fd83836af6d6bd2e4ed4a7e45eb3b30fde27a501b3b116',
  cryptoData: [
    {
      icon: logo,
      symbol: 'PLTL',
      name: 'Ploutos',
      price: 0.00,
      quantity: 0.00,
      network: 'Base',
      address: '0x45254F4c45545341f2a657501881B20439cBAF90',
      decimals: 9,
    },
    {
      icon: ethLgoo,
      symbol: 'ETH',
      name: 'Ethereum',
      price: 0,
      quantity: 0.00,
      network: 'Base',
      address: '0x4200000000000000000000000000000000000006',
      decimals: 18,
    },
  ],

  transactionData: [
    // {
    //   date: '2024-06-27',
    //   type: 'send',
    //   symbol: 'ETH',
    //   amount: '5',
    //   txid: '0x9i8u7y6t5r4e3w2q',
    //   address: '0xdBBd9A8A2AAB27e928DD60E30fC0668f32D74a67',
    // },
    // {
    //   date: '2024-06-26',
    //   type: 'recieve',
    //   symbol: 'PLTL',
    //   amount: '11050',
    //   txid: '0x8h7g6f5d4s3a2q1w',
    //   address: '0xdBBd9A8A2AAB27e928DD60E30fC0668f32D74a67',
    // },
  ],
};

export default data;
